import React, { useEffect, useRef } from "react";
import "./StatsSection.css";

const stats = [
  { target: 800,
    label: "Clients",
    icon: "fas fa-users",
    initial: "0+" },
  {
    target: 100,
    label: "Crores Managed",
    icon: "fas fa-chart-pie",
    initial: "0+",
  },
  {
    target: 20,
    label: "Years of Experience",
    icon: "fas fa-trophy",
    initial: "0+",
  },
  {
    target: 99,
    label: "Client Satisfaction",
    icon: "fas fa-heart",
    initial: "0%",
  },
];

function formatVal(value, target) {
  if (target === 99) return `${value}%`;
  if (target === 100) return `${value}+ Cr`;
  return `${value}+`;
}

const StatsSection = () => {
  const sectionRef = useRef(null);
  const containerRef = useRef(null);
  const playedRef = useRef(false);

  useEffect(() => {
    const revealObs = new IntersectionObserver(
      (entries) =>
        entries.forEach(
          (e) => e.isIntersecting && e.target.classList.add("show"),
        ),
      { threshold: 0.1 },
    );
    if (containerRef.current) revealObs.observe(containerRef.current);

    const statsObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !playedRef.current) {
            playedRef.current = true;
            document.querySelectorAll(".wc-ui-stat-number").forEach((el) => {
              const tgt = parseInt(el.getAttribute("data-target"), 10);
              const start = performance.now();
              const tick = (now) => {
                const p = Math.min((now - start) / 1800, 1);
                el.textContent = formatVal(
                  Math.floor((1 - Math.pow(1 - p, 4)) * tgt),
                  tgt,
                );
                if (p < 1) requestAnimationFrame(tick);
              };
              requestAnimationFrame(tick);
            });
          }
        });
      },
      { threshold: 0.3 },
    );
    if (sectionRef.current) statsObs.observe(sectionRef.current);

    return () => {
      revealObs.disconnect();
      statsObs.disconnect();
    };
  }, []);

  return (
    <section className="wc-ui-stats-section" ref={sectionRef}>
      <div className="wc-ui-stats-container wc-ui-reveal" ref={containerRef}>
        <div className="wc-ui-stats-grid">
          {stats.map((s, i) => (
            <div className="wc-ui-stat-card" key={i}>
              <h2 className="wc-ui-stat-number" data-target={s.target}>
                {s.initial}
              </h2>
              <p className="wc-ui-stat-label">{s.label}</p>
              <div className="wc-ui-stat-icon">
                <i className={s.icon}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
